export const DEMO_PHONE = "+966500000000";

export const isDemoUser = (phone: string | null | undefined): boolean =>
  phone === DEMO_PHONE;
